export const CognitoGroups = {
    ADMIN: "IdwalAdministrators",
    SURVEYOR: "IdwalSurveyors",
    DOC_COLLECTION: "DOCUMENT_COLLECTION",
    SUPER_ADMIN: "IdwalSuperAdmins"
};
